import { SocialDistanceOutlined } from "@mui/icons-material";

const characterReferenceResource = {
    title: "Character References",
    singular: "Character Reference",

    collectionField: "characterReferences",

    displayField: "lastName",
    icon: SocialDistanceOutlined,

    columns: [
        /*{
            field: "relation",
            header: "Relation",
            type: "text"
        },*/
        {
            field: "lastName",
            header: "Last Name",
            type: "text"
        },
        {
            field: "firstName",
            header: "First Name",
            type: "text"
        },
        {
            field: "middleName",
            header: "Middle Name",
            type: "text"
        },
        {
            field: "phoneNumber",
            header: "Phone Number",
            type: "text"
        }
    ],

    fields: {
        relation: {
            name: "relation",
            label: "Relation",
            type: "text"
        },
        firstName: {
            name: "firstName",
            label: "First Name",
            type: "text",
            required: true
        },
        middleName: {
            name: "middleName",
            label: "Middle Name",
            type: "text"
        },
        lastName: {
            name: "lastName",
            label: "Last Name",
            type: "text",
            required: true
        },
        suffix: {
            name: "suffix",
            label: "Suffix",
            type: "text"
        },
        dateOfBirth: {
            name: "dateOfBirth",
            label: "Date of Birth",
            type: "date"
        },
        birthPlace: {
            name: "birthPlace",
            label: "Birth Place",
            type: "text"
        },
        occupation: {
            name: "occupation",
            label: "Occupation",
            type: "text"
        },
        employer: {
            name: "employer",
            label: "Employer",
            type: "text"
        },
        maidenName: {
            name: "maidenName",
            label: "Maiden Name",
            type: "text"
        },
        phoneNumber: {
            name: "phoneNumber",
            label: "Phone Number",
            type: "text"
        },
        phoneNumberExt: {
            name: "phoneNumberExt",
            label: "Phone Number Ext.",
            type: "text"
        },
        adress1: {
            name: "adress1",
            label: "Address 1",
            type: "text"
        },
        adress2: {
            name: "adress2",
            label: "Address 2",
            type: "text"
        },
        adress3: {
            name: "adress3",
            label: "Address 3",
            type: "text"
        }
    }
};

export default characterReferenceResource;
